export const SET_USER_LOG = 'SET_USER_LOG'
export const RESET_USER_LOG = 'RESET_USER_LOG'
